export const CLASS_NAME = 'cst-icon-nav-map'
